
class Store {
    private permissions = new Map<string, boolean>()

    setPermissions(permissions: object) {
        this.permissions = new Map(Object.entries(permissions));
        console.log("permissions");
        console.log(this.permissions);
    }

    getPermission(name: string): boolean {
        return this.permissions.get(name) || false;
    }

    permissionsLoaded(): boolean {
        return this.permissions.size > 0;
    }
}
  
export default new Store();